import { type } from '@testing-library/user-event/dist/type';
import * as types from './actionTypes';

export const getpaySlipdetails = (formData) => ({
  type: types.FETCH_EMPLOYEE_PAYSLIPS,
  payload: formData,
});

export const getWagesalaryRegister = (formData) => ({
  type: types.FETCH_EMPLOYEE_WAGEREGISTER,
  payload: formData,
});

export const getBankStatementDetails = (formData) => ({
  type: types.FETCH_BANKSTATEMENT_DETAILS,
  payload: formData,
});

export const clearBankStatementDetails = () => ({
  type: types.CLEAR_BANKSTATEMENT_DETAILS,
});

export const featchSectionWageList = (formData) => ({
  type: types.FETCH_SECTION_WAGE_LIST,
  payload: formData,
});

export const clearSectionWageList = () => ({
  type: types.CLEAR_SECTION_WAGE_LIST,
});

export const getEmployeesCTCReport = (formData) => ({
  type: types.FETCH_EMPLOYEE_CTCT_LIST,
  payload: formData,
});

export const getMonthlyESIList = (formData) => ({
  type: types.FETCH_MONTHLY_ESI_LIST,
  payload: formData,
});

export const clearMonthlyESIList = () => ({
  type: types.CLEAR_MONTHLY_ESI_LIST,
});

export const getMonthlyPFList = (formData) => ({
  type: types.FETCH_MONTHLY_PF_LIST,
  payload: formData,
});

export const clearMonthlyPFList = () => ({
  type: types.CLEAR_MONTHLY_PF_LIST,
});

export const getpayRegSummaryList = (formData) => ({
  type: types.FETCH_PAYREG_SUMMARY_LIST,
  payload: formData,
});

export const clearpayRegSummaryList = () => ({
  type: types.CLEAR_PAYREG_SUMMARY_LIST
});

export const getpayEmpReport = (formData) => ({
  type: types.FETCH_GETPAY_EMPLOYEE_REPORT_LIST,
  payload: formData,
});

export const clearGetpayEmpReportList = () => ({
  type: types.CLEAR_GETPAY_EMPLOYEE_REPORT_LIST
});

export const clearapproveError1 = () => ({
  type: "CLEAR_PAYSLIP_ERROR",
});